import template from "./date-link.html";

const DateLinkComponent = {
  bindings: {
    name: "@",
    label: "@",
    model: "=",
    minDate: "<",
    maxDate: "<",
    required: "<",
  },
  template: template,
  controller: class DateLinkController {
    /* @ngInject */
    constructor($scope) {
      this.$scope = $scope;
    }

    $onInit() {
      this.format = "dd/MM/yyyy";

      this.options = {
        startingDay: 1,
        showWeeks: false,
        minDate: this.minDate,
        maxDate: this.maxDate,
      };

      this.isOpen = false;

      this.$scope.$watch(
        () => this.minDate,
        (newVal, oldVal) => {
          if (!angular.equals(newVal, oldVal))
            this.options = {
              startingDay: 1,
              showWeeks: false,
              minDate: this.minDate,
            };
        }
      );
      this.$scope.$watch(
        () => this.maxDate,
        (newVal, oldVal) => {
          if (!angular.equals(newVal, oldVal))
            this.options = {
              startingDay: 1,
              showWeeks: false,
              maxDate: this.maxDate,
            };
        }
      );
    }

    open() {
      this.isOpen = true;
    }
  },
};

export default DateLinkComponent;
